import { render, staticRenderFns } from "./SelectProyecto.vue?vue&type=template&id=7ca4b4de&"
import script from "./SelectProyecto.vue?vue&type=script&lang=js&"
export * from "./SelectProyecto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports